export const headers = {
  Authorization: `Bearer ${process.env.REACT_APP_strapiToken}`,
};
export const cmsHeaders = {
  Authorization: `Bearer ${process.env.REACT_APP_cmsToken}`,
};

export const stripHtml = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
